import { JSONSchema7Object, ConfigurableFormConfig } from "../../../types";
import * as formElements from "./formElements";
//import validateSchema from "./customerConsent.json";
import formElementsSchema from "./formElements.json";

export const formConfig: ConfigurableFormConfig = {
  fields: [
    {
      ...formElements.sectionHeader,
      label: "customer.advisorForm.title"
    },
    {
      ...formElements.sectionText,
      label: "customer.advisorForm.intro"
    },
    {
      ...formElements.fieldTags,
      id: "axis",
      name: "axis",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.axis.title",
          sortOptionsAlphabetically: false
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "franchise",
      name: "franchise",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.franchise.title",
          sortOptionsAlphabetically: false
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "loyalty",
      name: "loyalty",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.loyalty.title",
          sortOptionsAlphabetically: false
        }
      }
    }
  ],
  //validateSchema: validateSchema as JSONSchema7Object,
  refSchemas: [formElementsSchema as JSONSchema7Object],
  labels: {
    buttonBack: "general.buttons.back.label",
    buttonNext: "general.buttons.continue.label",
    buttonSubmit: "general.buttons.submit.label",
    buttonReset: "reset"
  },
  buttonsOnTop: false
};

export default formConfig;
